import { BillDetailsItemType } from '../types';

const BILL_LINE_ITEM_TYPE_ORDER = [
  BillDetailsItemType.Project,
  BillDetailsItemType.TimeOffType,
  BillDetailsItemType.Overhead,
  BillDetailsItemType.Client,
  BillDetailsItemType.Unlinked,
] as const;

interface BillLineItem {
  entityType: BillDetailsItemType;
}

/** Keeps bill lines in the same project → time-off → custom-line order as bill generation. */
export function groupBillLineItemIndexesByType(items: readonly BillLineItem[]): number[] {
  return BILL_LINE_ITEM_TYPE_ORDER.flatMap(type =>
    items.flatMap((item, index) => (item.entityType === type ? [index] : []))
  );
}
